export enum SkipAbleValidation {

    MarginPercentage = 0,
    AccountEquity = 1,
    UnusedMargin = 2,
    EMTPercentage = 3,
}
